<template>
    <div class="flex flex-col rounded-xl border-solid border @container text-slate-800"
        :class="props.selected ? 'border-sky-200 bg-sky-50 ' : 'border-slate-100 bg-white'">
        <div class="group/checkbox flex grow cursor-pointer items-start gap-2 rounded-l-lg rounded-r-sm py-4 pl-3 @xl:pl-4 pr-3 transition @xl:items-center"
            :class="props.selected ? 'hover:bg-sky-100/50' : 'hover:bg-sky-50/50'"
            role="button"
            tabindex="0"
            data-test="toggle-item"
            @click.prevent="emit('toggle')"
            @keydown.space.prevent="emit('toggle')"
            @keydown.enter.prevent="emit('toggle')">
            <div
                class="relative mt-0.5 transition duration-150 group-hover/checkbox:scale-110 group-hover/checkbox:duration-300 group-hover/checkbox:ease-[cubic-bezier(0.5,4,0.4,1)] group-active/checkbox:scale-95 group-active/checkbox:duration-150 group-active/checkbox:ease-in-out @xl:mt-0">
                <vx-checkbox :modelValue="props.selected"></vx-checkbox>
            </div>

            <div
                class="grow origin-left max-w-full text-sm leading-tight transition duration-150 ease-in-out break-all group-active/checkbox:-translate-x-[1.5px]">
                <slot>{{ props.label }}</slot>
            </div>
        </div>
    </div>

</template>
<script setup>
import { VxCheckbox } from '@voxie/frontend-components';

const props = defineProps({
    label: {
        required: true,
    },
    selected: {
        type: Boolean,
    }
});

const emit = defineEmits(['toggle']);

</script>
